<boi-mortgage-app-section-navigation #boiTabWrapper (detectChanges)="changeDetectorRef.detectChanges()">
    <div class="title-bar">
        <h1 class="title-bar-text vo-heading-regular-22">{{referenceDataLabels.SectionTitleOutgoings|localizeLabel}}</h1>

        <span class="required-label vo-body-regular-14 vo-display-none" [innerHtml]="referenceDataLabels.MandatoryFields | localizeLabel"></span>
    </div>

    <boi-form-information-box [message]="referenceDataLabels.ListAnyOutstandingDebts">
    </boi-form-information-box>

    <boi-accordion>
        <boi-accordion-item #accordionItem1 [title]="referenceDataLabels.SectionTitleOutgoings|localizeLabel"
            [class]="'js-section-' + referenceDataLabels.SectionTitleOutgoings | removeWhiteSpaces"
            [data]="sections.YourOutgoings.AboutYourOutgoings">
            <boi-progress-stepper-item header [status]="sections.YourOutgoings.AboutYourOutgoings"
                [hasSubmitValidationError]="hasSubmitValidationError">
            </boi-progress-stepper-item>
            <boi-your-outgoings-about></boi-your-outgoings-about>
            <boi-save-application class="buttons__bar" [saveButtonLabel]="saveContinueButtonLabel"
            [hideActionButton]="mortgageApplication?.IsApplicationReadOnly || (mortgageApplication?.IsFactFind && mortgageApplication.IsFactFindReadOnly)"
            (cancel)="boiTabWrapper.goToSection(referenceDataLabels.SectionTitleOutgoings)"
            (save)="boiTabWrapper.goToNextIncompleted(accordionItem1)">
            </boi-save-application>
        </boi-accordion-item>
        <div class="vo-separator-line my-15"></div>
        <boi-accordion-item #accordionItem2 [title]="referenceDataLabels.SectionTitleDeclaration|localizeLabel"
            [class]="'js-section-' + referenceDataLabels.SectionTitleDeclaration | removeWhiteSpaces"
            [data]="sections.YourOutgoings.Declaration">
            <boi-progress-stepper-item header [status]="sections.YourOutgoings.Declaration"
                [hasSubmitValidationError]="hasSubmitValidationError">
            </boi-progress-stepper-item>
            <boi-your-outgoings-declaration></boi-your-outgoings-declaration>
            <boi-save-application class="buttons__bar" [saveButtonLabel]="saveContinueToNextStepButtonLabel"
                [hideActionButton]="mortgageApplication?.IsApplicationReadOnly || (mortgageApplication?.IsFactFind && mortgageApplication.IsFactFindReadOnly)"
                (cancel)="boiTabWrapper.goToSection(referenceDataLabels.SectionTitleDeclaration)"
                (save)="boiTabWrapper.goToNextIncompleted(accordionItem2)"></boi-save-application>
        </boi-accordion-item>
    </boi-accordion>
</boi-mortgage-app-section-navigation>
